var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"my-account-page"},[_c('MyLayout',{attrs:{"menuList":_vm.myAccountMenu,"menuKey":_vm.menuKey}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }